<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionAssetSendingOfDeliverablesDropDownFilters"
  >
    <form
      autocomplete="off"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.asunto.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.asunto"
                class="a-input-primary"
                name="asunto"
                type="text"
              />
            </div>
          </li>
        </ul>

        <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.mensaje.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.mensaje"
                class="a-input-primary"
                name="mensaje"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.tipo.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.tipo"
                :elements="tipos"
                key-field="id"
                name="tipo"
                reference="tipo"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul
          v-if="!element.fecha_inicio"
          class="m-dropdown-list"
        >
          <li>
            <a href="#">
              {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.dia.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model.number="filter.dia"
                class="a-input-primary"
                name="mensaje"
                type="number"
              />
            </div>
          </li>
        </ul>

        <ul
          v-else
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.fecha.desde.placeholder')"
              />
              <span class="margin-bottom-xlarge"></span>
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionAssetSendingOfDeliverablesDropDownFilters.inputs.fecha.hasta.placeholder')"
              />
            </div>
          </li>
        </ul>
      </section>

      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.buttons.reload') }}
        </button>
        <button
          class="a-button-primary a-button-assets-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionAssetSendingOfDeliverablesDropDownFilters.buttons.search') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSendingOfDeliverablesDropDownFilters',

  props: {
    element: Object,
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      tipos: [
        {
          id: '',
          nombre: 'Todos los Tipos'
        },
        {
          id: 0,
          nombre: 'Mensaje'
        },
        {
          id: 1,
          nombre: 'Activación'
        }
      ],

      filter: {
        asunto: '',
        dia: '',
        tipo: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        mensaje: '',
        pagina: 1
      }
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.asunto = this.filterSeted.asunto
        // this.filter.mensaje = this.filterSeted.mensaje
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  methods: {
    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionAssetSendingOfDeliverablesDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
